/**
 * La pastille du règlement d'une inscription, pour les écrans du personnel.
 *
 * Un seul dessin pour tous les écrans qui disaient « Payé » ou « En attente »
 * d'après `payment_status` : les mots et les couleurs viennent de
 * `lib/inscriptions/reglement`, l'infobulle nomme la facture lue.
 */
import clsx from 'clsx';
import type { ReglementAffiche } from '../../lib/inscriptions/reglement';

export function PastilleDeReglement({ statut, className }: { statut: ReglementAffiche; className?: string }) {
  return (
    <span
      className={clsx('inline-flex items-center px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap', statut.classe, className)}
      title={statut.titre}
    >
      {statut.libelle}
    </span>
  );
}
